import React from "react"
import Cabecalho from "../Cabecalho"
import { ResultadoPesquisa } from "./components/ResultadoPesquisa"

export function PesquisaSatisfacaoFornecedor() {
    return (
        <>
            <Cabecalho pagina="Pesquisa de Satisfação" />
            <ResultadoPesquisa />
        </>
    )
}
